export default "__VITE_ASSET__QDpn_zdx__"